export enum INTEGRATION_CATEGORY {
	'TMS' = 'TMS',
	'VETTING' = 'VETTING',
	'PRIVATE_FLEETS' = 'PRIVATE_FLEETS',
	'PRICING' = 'PRICING',
}
